{
	"loadingMessage": "Cargando cuentas...",
	"errorMessage": "Error al cargar datos",
	"emptyMessage": "No se encontraron cuentas",
	"noSearchResults": "Plan de cuentas no existe",
	"searchHint": "Busque un plan de cuentas ya registrado"
}
